module.exports = __webpack_public_path__ + "img/shanchu.10a636fe.png";